
    import Vue from "vue";
    import ApiButton from "@/components/ApiButton.vue";
    import Component from "vue-class-component";
    import * as toastr from "toastr";
    import { ApiClient } from "@/utilities/ApiClient";
    import { BookingAllocation, IBookingAllocation } from "@/model/BookingAllocation";
    import { BookingAllocationDate, IBookingAllocationDate } from "@/model/BookingAllocationDate";
    import { BookingAllocationDateVM, IBookingAllocationDateVM } from "@/model/Api/VM/BookingAllocationDateVM";
    import { Prop } from "vue-property-decorator";
    import vuescroll from "vuescroll";
    import { Utils } from "@/utilities/Utils";
    
    @Component({
        components: { 
            ApiButton
        }
    })

    export default class AllocationDateModal extends Vue {

        //
        // -- properties
        //

        private allocation = new BookingAllocation();
        private employeeName: string = "";
        private timeOptions: Array<string> = ["00:00", "00:30", "01:00", "01:30", "02:00", "02:30", 
        "03:00", "03:30", "04:00", "04:30", "05:00", "05:30", "06:00", "06:30", "07:00", "07:30", 
        "08:00", "08:30", "09:00", "09:30", "10:00", "10:30", "11:00", "11:30", "12:00", "12:30", 
        "13:00", "13:30", "14:00", "14:30", "15:00", "15:30", "16:00", "16:30", "17:00", "17:30", 
        "18:00", "18:30", "19:00", "19:30", "20:00", "20:30", "21:00", "21:30", "22:00", "22:30", 
        "23:00", "23:30"];
        private allocationDate = new BookingAllocationDateVM();
        private removeDate: boolean = false;
        private bookingID: number = 0;
        private selectTime: boolean = false;

        //
        // -- methods
        //

        show(allocationID: number, employeeName: string, allocationDate: IBookingAllocationDate, bookingID: number) {
            Utils.resetObject(this.allocationDate)
            this.selectTime = true;
            this.removeDate = false;
            this.employeeName = employeeName;
            this.bookingID = bookingID;
            this.loadAllocation(allocationID);
            this.loadAllocationDate(allocationDate.id);

            

            this.$bvModal.show("allocationDateModal");
        }

        async loadAllocation(id: number) {
            const response = await ApiClient.get(`/Api/Booking/Allocation?id=${id}`)
            this.allocation.update(response);
        }

        async loadAllocationDate(id: string) {
            const response = await ApiClient.get(`/Api/Booking/allocationDate?id=${id}`)
            this.allocationDate.update(response);
        }

        cancel() {
            this.$bvModal.hide("allocationDateModal");
        }

        async removeAllocatedDate() {
            // https://vuescrolljs.yvescoding.org/guide/configuration.html
            // const scrollLeft = this.$refs.vueScrollBar as vuescroll & { getPosition: () => 0 };   
            // const scroller = scrollLeft.getPosition().scrollLeft
            // const scroll = this.$refs.vueScrollBar as vuescroll & { scrollTo: () => 0 };
 
            const postData = { bookingID: this.bookingID, objectID: this.allocationDate.id }
            await ApiClient.post("/Api/Booking/DateAssign", postData, event);
            this.$emit("loadAllocationsDetail");
            this.$emit("loadRoomTotals");
            this.$emit("loadHotels");
            this.$bvModal.hide("allocationDateModal");
            // scroll.scrollTo({x: scroller}, 500)
        }

        async save(event: Event) {
            console.log(this.allocation.latestCheckIn)
            console.log(this.allocationDate.latestCheckIn)
            if (this.allocation.latestCheckInTime === this.allocationDate.latestCheckInTime) {
                this.allocationDate.latestCheckIn = new Date(Utils.emptyDateValue);
            }

            await ApiClient.post("/Api/Booking/AllocationDateCheckInTimeSave", this.allocationDate, event);
            toastr.success("Saved");
            this.$emit("loadAllocationsDetail");
            this.$emit("loadRoomTotals");
            this.$emit("loadHotels");
            this.$bvModal.hide("allocationDateModal");
        }

        async setToDefaultTime() {
            console.log(this.allocationDate.latestCheckIn)
            this.allocationDate.latestCheckIn = this.allocation.latestCheckIn;
            console.log(this.allocationDate.latestCheckIn)
        }
    }

